export default __webpack_public_path__ + "static/media/favicon.b170189c.png";